/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import axiosConfig from '../axiosConfig';
import axios from 'axios';


class Footer extends React.Component {

    constructor(props) {
        super(props)

        let appState = localStorage.getItem('appState')
        if (appState) {
            appState = JSON.parse(localStorage.getItem('appState'))
        }

        this.state = {
            isLoggedIn: appState ? appState.isLoggedIn : false,

            // footer-contents
            app_site_url: process.env.REACT_APP_APP_SITE,
            app_site_storage_path: process.env.REACT_APP_APP_SITE_STORAGE_PATH,
            footer_newsletter: {
                title: "",
                description: "",
                email_to: "",
            },
            footer_menus: [],
            footer_social_sites: [],
            footer_payments: [],
            site_logo: "",
            copyright_text: "",

            subscribe_to: "",
            subscribe_text: "subscribe"

        }

        // header-contents
        this.getFooterContents = this.getFooterContents.bind(this)
        this.handleSubscribe = this.handleSubscribe.bind(this)
    }

    getFooterContents() {
        axiosConfig.get("/api/merchant-footer-contents")
            .then(res => {
                if (res.data.success) {
                    let { footer_newsletter, footer_menus, footer_social_sites, logo: site_logo, footer_payments, copyright_text } = res.data.data
                    this.setState({
                        footer_newsletter,
                        footer_menus,
                        footer_social_sites,
                        site_logo,
                        footer_payments,
                        copyright_text,
                    })
                    if (footer_newsletter) {
                        this.state({
                            footer_newsletter
                        })
                    }

                }
            })
            .catch(err => {

            })
    }

    componentDidMount() {
        this.getFooterContents();
    }

    handleSubscribe(e) {
        e.preventDefault();

        this.setState({
            subscribe_text: "subscribing ..."
        })
        let url = "https://api.sendgrid.com/v3/marketing/contacts"
        let data = {

            "list_ids": [

            ],
            "contacts": [
                {
                    "address_line_1": "",
                    "address_line_2": "",
                    "alternate_emails": [
                    ],
                    "city": "",
                    "country": "",
                    "email": this.state.subscribe_to,
                    "first_name": "",
                    "last_name": "",
                    "postal_code": "",
                    "state_province_region": "",
                    "custom_fields": {}
                }
            ]
        }

        axios.put(url, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${process.env.REACT_APP_SENDGRID_API} `
            }
        }).then(res => {
            if (res.status === 202) {
                this.setState({
                    subscribe_to: "",
                    subscribe_text: "subscribed"
                })
            } else {
                this.setState({
                    subscribe_text: "try again"
                })
            }
        })

    }


    render() {

        let footer_menus_mapping = this.state.footer_menus.map((el, index) => {
            return <li key={el.id} className="text-capitalize">
                <Link to={el.url}>
                    {el.label}
                </Link>
            </li>
        })

        let footer_payments_mapping = this.state.footer_payments.map((el, index) => {
            return <li key={index}><i className={el.icon} /></li>
        })

        let footer_social_sites_mapping = this.state.footer_social_sites.map((el, index) => {
            return <li key={index}>
                <a href={el.url}><i className={el.icon} /></a>
            </li >
        })

        return (
            <>
            <div id="footer" className="no-print">
                <footer className="site-footer footer" role="contentinfo">
                    <div className="footer-top">
                    <div className="container px-4 px-lg-5">
                        <div className="footer_info">
                        <p>
                             <span>Need help? Call <a href="tel:+15747374104" style={{ color: 'inherit', textDecoration: 'underline' }}>+1 574 737 4104</a> or Email <a href="mailto:info@thevaluefinds.com" style={{ color: 'inherit', textDecoration: 'underline' }}>info@thevaluefinds.com</a></span>
                        </p>
                        </div>
                        <div className="footer-link">
                        <div className="footer-col-left">
                            <div className="row w-100">
                            {/* ABOUT US */}
                            <div className="col-footer col-md-6">
                                <h3 className="footer-title dropdow-mb"><span>ABOUT US</span></h3>
                                <ul>
                                <li><Link to="/pages/about-us" title="Our Company" className="foot-link"><span>Our Company</span></Link></li>
                                <li><Link to="/pages/contact-us" title="Contact us" className="foot-link"><span>Contact us</span></Link></li>
                                <li><Link to="/policies/privacy-policy" title="Privacy Policy" className="foot-link"><span>Privacy Policy</span></Link></li>
                                <li><a href="#" title="Terms of Service" className="foot-link"><span>Terms of Service</span></a></li>
                                </ul>
                            </div>

                            {/* CUSTOMER SERVICE */}
                            <div className="col-footer col-md-6">
                                <h3 className="footer-title dropdow-mb"><span>CUSTOMER SERVICE</span></h3>
                                <ul>
                                <li><a href="#" title="FAQs" className="foot-link"><span>FAQs</span></a></li>
                                <li><a href="#" title="The Value Finds Reviews" className="foot-link"><span>The Value Finds Reviews</span></a></li>
                                <li><Link to="/policies/shipping-policy" title="Shipping Policy" className="foot-link"><span>Shipping Policy</span></Link></li>
                                <li><Link to="/policies/refund-policy" title="Return and Refund" className="foot-link"><span>Return and Refund</span></Link></li>
                                </ul>
                            </div>

                            {/* BEYOND A HOME GOODS STORE */}
                            <div className="col-footer col-12 col-md-6">
                                <h3 className="footer-title dropdow-mb"><span>BEYOND A HOME GOODS STORE</span></h3>
                                <ul>
                                <li><a href="#" title="Donations" className="foot-link"><span>Donations</span></a></li>
                                <li><a href="#" title="Franchise Opportunity" className="foot-link"><span>Franchise Opportunity</span></a></li>
                                </ul>
                            </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="footer-col-right">
                            <div className="footer-newsletter">
                            <h3 className="newsletter-title footer-title"><span>Signup For Our Newsletter</span></h3>
                            <p className="newsletter-des"><span>Receive our latest updates about our products and promotions.</span></p>
                            
                            <section className="newsletter">
                                <div className="block-content">
                                    <form onSubmit={this.handleSubscribe} >
                                        <div className="input-group">
                                            <div className="">
                                                <input type="email"
                                                    name="subscribe_to"
                                                    value={this.state.subscribe_to}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            "subscribe_to": e.target.value,
                                                            "subscribe_text": "subscribe"
                                                        })
                                                    }}
                                                    className="input-group-field" placeholder="Type your email..." />
                                                {/* <svg preserveAspectRatio="none"><rect x={2} y={2} rx={6} height="100%" width="100%" /></svg> */}
                                                <span className="bottom" />
                                            </div>
                                            <button type="submit" className="btn"
                                            disabled={!this.state.subscribe_to}
                                            >{this.state.subscribe_text}</button>
                                        </div>
                                    </form>
                                </div>
                            </section>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div className="footer-bottom">
                    <div className="container px-4 px-lg-5">
                        <div className="row align-items-center justify-content-between">
                        <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                            <address>
                                <div>The Value Finds 2021</div>
                                <div>v1.0.5</div>
                            </address>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                            <ul className="payment-methods">
                            <li><img src="//www.thevaluefinds.com/cdn/shop/files/visa_ec8e37bb-5638-42ab-94ed-c24333cd09a1_x100.png?v=1627065033" alt="visa" sizes="52px" /></li>
                            <li><img src="//www.thevaluefinds.com/cdn/shop/files/master_x100.png?v=1627065048" alt="master" sizes="52px" /></li>
                            <li><img src="//www.thevaluefinds.com/cdn/shop/files/ae_x100.png?v=1627065439" alt="american_express" sizes="52px" /></li>
                            <li><img src="//www.thevaluefinds.com/cdn/shop/files/discover_x100.png?v=1627065312" alt="discover" sizes="52px" /></li>
                            <li><img src="//www.thevaluefinds.com/cdn/shop/files/pp_x100.png?v=1627065610" alt="paypal" sizes="52px" /></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    </div>
                </footer>
                <div className="footer-sticky">
                        {/*  sticky add to cart */}
                        <div className="sticky-addcart js-stickyAddToCart closed">
                            <div className="container">
                                <div className="row">
                                    <div className="col-auto sticky-addcart_image">
                                        <a href="product.html">
                                            <img src="/images/skins/fashion/products/product-01-1.jpg" alt="" />
                                        </a>
                                    </div>
                                    <div className="col col-sm-5 col-lg-4 col-xl-5 sticky-addcart_info">
                                        <h1 className="sticky-addcart_title">Leather Pegged Pants</h1>
                                        <div className="sticky-addcart_price">
                                            <span className="sticky-addcart_price--actual">$180.00</span>
                                            <span className="sticky-addcart_price--old">$210.00</span>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_options  prd-block prd-block_info--style1">
                                        <div className="select-wrapper">
                                            <select className="form-control form-control--sm">
                                                <option value>--Please choose an option--</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_actions">
                                        <div className="prd-block_qty">
                                            <span className="option-label">Quantity:</span>
                                            <div className="qty qty-changer">
                                                <button className="decrease" />
                                                <input type="number" className="qty-input" defaultValue={1} data-min={1} data-max={1000} />
                                                <button className="increase" />
                                            </div>
                                        </div>
                                        <div className="btn-wrap">
                                            <button className="btn js-prd-addtocart" data-fancybox data-src="#modalCheckOut">Add to cart
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*added to cart*/}
                        <div className="popup-addedtocart js-popupAddToCart closed" data-close={50000}>
                            <div className="container">
                                <div className="row">
                                    <div className="popup-addedtocart-close js-popupAddToCart-close"><i className="icon-close" /></div>
                                    <div className="popup-addedtocart-cart js-open-drop" data-panel="#dropdnMinicart"><i className="icon-basket" /></div>

                                    {/* <div className="col-auto popup-addedtocart_logo">
                                        <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="/images/logo-white-sm.png" className="lazyload fade-up" alt="" />
                                    </div> */}

                                    <div className="col popup-addedtocart_info">
                                        <div className="row">
                                            <a href="product.html" className="col-auto popup-addedtocart_image">
                                                <span className="image-container w-100">
                                                    <img className="img" style={{
                                                        height: "100%"
                                                    }} src="/images/skins/fashion/products/product-01-1.jpg" alt="" />
                                                </span>
                                            </a>
                                            <div className="col popup-addedtocart_text">
                                                <a href="product.html" className="popup-addedtocart_title"> </a>
                                                <span className="popup-addedtocart_message">Added to
                                                    &nbsp;
                                                    {/* <a href="cart.html" className="underline">Cart</a> */}
                                                    <Link to="/cart" className="underline">
                                                        Cart
                                                    </Link>
                                                </span>
                                                <span className="popup-addedtocart_error_message" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto popup-addedtocart_actions">
                                        <span>You can continue</span>
                                        {/* <a href="#" className="btn btn--grey btn--sm js-open-drop"
                                            data-panel="#dropdnMinicart">
                                            <i className="icon-basket" />
                                            <span>Check Cart</span>
                                        </a> */}
                                        <Link to="/cart" className="btn btn--grey btn--sm js-open-drop" data-panel="#dropdnMinicart">
                                            <i className="icon-basket" /><span>Check Cart</span>
                                        </Link>

                                        <span>or</span>
                                        <Link to="/checkout" className="btn btn--invert btn--sm">
                                            <i className="icon-envelope-1" /><span>Check out</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*  select options */}
                        <div className="sticky-addcart popup-selectoptions js-popupSelectOptions closed" data-close={500000}>
                            <div className="container">
                                <div className="row">
                                    <div className="popup-selectoptions-close js-popupSelectOptions-close"><i className="icon-close" /></div>
                                    <div className="col-auto sticky-addcart_image sticky-addcart_image--zoom">
                                        <a href="#" data-caption>
                                            <span className="image-container"><img src="#" alt="" /></span>
                                        </a>
                                    </div>
                                    <div className="col col-sm-5 col-lg-4 col-xl-5 sticky-addcart_info">
                                        <h1 className="sticky-addcart_title"><a href="#">&nbsp;</a></h1>
                                        <div className="sticky-addcart_price">
                                            <span className="sticky-addcart_price--actual" />
                                            <span className="sticky-addcart_price--old" />
                                        </div>
                                        <div className="sticky-addcart_error_message">Error Message</div>
                                    </div>
                                    <div className="col-auto sticky-addcart_options prd-block prd-block_info--style1">
                                        <div className="select-wrapper">
                                            <select className="form-control form-control--sm sticky-addcart_options_select">
                                                <option value="none">Select Option please..</option>
                                            </select>
                                            <div className="invalid-feedback">Can't be blank</div>
                                        </div>
                                    </div>
                                    <div className="col-auto sticky-addcart_actions">
                                        <div className="prd-block_qty">
                                            <span className="option-label">Quantity:</span>
                                            <div className="qty qty-changer">
                                                <button className="decrease" />
                                                <input type="number" className="qty-input" defaultValue={2} data-min={1} data-max={10000} />
                                                <button className="increase" />
                                            </div>
                                        </div>
                                        <div className="btn-wrap">
                                            <button className="btn js-prd-addtocart">Add to cart</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* back to top */}
                        <a className="back-to-top js-back-to-top compensate-for-scrollbar" href="#" title="Scroll To Top">
                            <i className="icon icon-angle-up" />
                        </a>
                        {/* loader */}
                        <div className="loader-horizontal js-loader-horizontal">
                            <div className="progress">
                                <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
            </div>
            </>
        );
    }
}

export default Footer;